var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-29
 * @brief refreshToken module
  *
 ********************************************************************/
//utils
import * as CONST from "../utils/Const";
import clog from "../utils/logUtils";
import * as HttpUtil from "../utils/api/HttpUtil";
/**
 * @brief AutoLogin 컴포넌트
 * @param
 * @returns react components
 */
export function refreshTokenFn() {
    return __awaiter(this, void 0, void 0, function* () {
        const userId = localStorage.getItem(CONST.STR_USERID); // to localStorage
        const refreshToken = localStorage.getItem(CONST.STR_REFRESHTOKEN); // to localStorage
        const refreshTokenExpireTime = localStorage.getItem(CONST.STR_REFRESHTOKEN_EXPIRETIME); // to localStorage
        let data = null;
        clog("IN AUTOLOGIN SUB IS USERID : " + userId);
        clog("IN AUTOLOGIN SUB TOKEN : " + refreshToken);
        clog("IN AUTOLOGIN SUB TOKEN : " + refreshTokenExpireTime);
        data = yield HttpUtil.PromiseHttp({
            "httpMethod": "POST",
            "appPath": `/api/v2/auth/token?token=${refreshToken}`,
            "appQuery": { "token": refreshToken },
            "userToken": "",
        });
        if (data) {
            if (data.codeNum == 200) {
            }
            else { // api if
                // need error handle
            }
        }
        return data;
    });
}
export default refreshTokenFn;
